import React, { FC } from 'react';
import styled from 'styled-components';
import { sideNavBarCSS } from './sideNavBarColors';

export const SideBarDivider: FC<React.PropsWithChildren<unknown>> = () => <StyledDividers />;

const StyledDividers = styled.div`
  height: 1px;
  width: 100%;
  background: ${sideNavBarCSS.divider.background};
  margin: ${({ theme }) => theme.spacingSize.m} 0 ${({ theme }) => theme.spacingSize.m} 0;
  padding: 0.5px;
`;
